// extracted by mini-css-extract-plugin
module.exports = {"slicedTitle":"FormatNotificationMessage_slicedTitle__M6r36"};